import TransferHistory from 'features/v2a/sender/screens/TransferHistory/TransferHistory';
import React from 'react';

export default function Page() {
  return <TransferHistory />;
}
